import Puzzle from "../../assets/images/Puzzle.png";
import DigicallTitle from "../../assets/images/digicall-title.png";

const Header = (props) => {
  return (
    <section className="w-full pt-[93px]">
      <div className="w-full bg-center bg-cover bg-[url('../../assets/images/header-bg.png')] flex justify-center">
        <div className="w-4/5 max-w-screen-xl py-14 md:py-32 flex flex-col md:flex-row justify-center items-center space-y-10 md:space-y-0">
          <div className="w-full md:w-1/2 px-5">
            <img
              data-aos="fade-right"
              width="527px"
              src={Puzzle}
              alt="puzzle"
            />
          </div>
          <div className="w-full md:w-1/2 px-5 space-y-5 flex flex-col justify-center items-center">
            <img
              data-aos="fade-left"
              src={DigicallTitle}
              alt="digicall title"
            />
            <ul className="text-center">
              <li data-aos="fade-left">
                <span className="text-[#00D7C4] font-medium text-sm md:text-xl">
                  {props.currentLang === "eng"
                    ? "APPLICATION DEADLINE:"
                    : "SON BAŞVURU TARİHİ:"}
                </span>{" "}
                <span className="text-white font-medium text-sm md:text-xl">
                  {props.currentLang === "eng" ? "5 MAY 2023" : "5 MAYIS 2023"}
                </span>
              </li>
              <li data-aos="fade-left">
                <span className="text-[#00D7C4] font-medium text-sm md:text-xl">
                  {props.currentLang === "eng"
                    ? "DAY ONE Meet The Digital Teams:"
                    : "BİRİNCİ GÜN Dijital Ekiplerle Tanışın:"}
                </span>{" "}
                <span className="text-white font-medium text-sm md:text-xl">
                  {props.currentLang === "eng"
                    ? "11 MAY 2023"
                    : "11 MAYIS 2023"}
                </span>
              </li>
              <li data-aos="fade-left">
                <span className="text-[#00D7C4] font-medium text-sm md:text-xl">
                  {props.currentLang === "eng"
                    ? "DAY TWO Experience a Real Life Case:"
                    : "İKİNCİ GÜN Gerçek Bir Vaka Deneyimi:"}
                </span>{" "}
                <span className="text-white font-medium text-sm md:text-xl">
                  {props.currentLang === "eng"
                    ? "12 MAY 2023"
                    : "12 MAYIS 2023"}
                </span>
              </li>
            </ul>
            <a
              data-aos="fade-up"
              className="block font-bold text-xl md:text-[2.5rem] md:leading-[3.5rem] text-[#1F36C7] bg-[#00D7C4] px-14 w-min rounded-[5px] hover:text-white"
              href={props.currentLang === "eng" ? "/#register" : "/#basvur"}
            >
              {props.currentLang === "eng" ? "APPLY" : "BAŞVUR"}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
